import image from '@/images/promos/marketing-tout.jpg'

export default {
  gaAction: 'marketing tout cta',
  smallHeadingText: 'THE EASIEST WAY TO SAVE',
  headingText: 'Become an Email Insider',
  contentText:
    'Unlock exclusive coupons, early access to sales and more when you sign up for Priceline emails',
  alt: '',
  image: `${image}?opto=true&auto=webp`,
  buttons: [
    {
      gaLabel: 'email sign up',
      buttonText: 'Sign Up',
      linkUrl: 'https://www.priceline.com/partner/email/signup'
    }
  ]
}
